import moment from 'moment'

export class EventTimePeriod {
  private constructor (
    readonly start: Date,
    readonly end: Date
  ) {}

  public static create (start: Date, end: Date): EventTimePeriod {
    return new EventTimePeriod(start, end)
  }

  public static createDefaultRange (): EventTimePeriod {
    const start = moment().startOf('day').add(8, 'hour')
    const end = moment(start).add(8, 'hour')

    return new EventTimePeriod(
      start.toDate(),
      end.toDate()
    )
  }

  public static editRange (start: Date, end: Date): EventTimePeriod {
    return new EventTimePeriod(start, end)
  }
}
